// Демо-данные окна «Диалоги» для главной Hub.
// Настройки: автозакрытие, автоматические заметки при закрытии, категории диалогов и тональность.
import { t } from "@/lib/i18n";

export const conversationsNav = [
  {
    group: t("Рабочее пространство"),
    items: [
      { id: "dashboard", label: t("Дашборд"), icon: "ri-dashboard-line" },
      { id: "general", label: t("Общие сведения"), icon: "ri-information-line" },
      { id: "user-settings", label: t("Настройки пользователей"), icon: "ri-user-settings-line" },
      { id: "team-settings", label: t("Настройки команды"), icon: "ri-team-line" },
      { id: "apps", label: t("Приложения"), icon: "ri-apps-line" },
      { id: "channels", label: t("Каналы"), icon: "ri-share-forward-line" },
      { id: "integrations", label: t("Интеграции"), icon: "ri-links-line" },
      { id: "widgets", label: t("Виджеты"), icon: "ri-layout-grid-line" },
    ],
  },
  {
    group: t("Настройки входящих"),
    items: [
      { id: "contact-fields", label: t("Поля контактов"), icon: "ri-contacts-book-2-line" },
      { id: "lifecycle", label: t("Жизненный цикл"), icon: "ri-refresh-line" },
      { id: "conversations", label: t("Диалоги"), icon: "ri-chat-3-line" },
      { id: "snippets", label: t("Шаблоны"), icon: "ri-file-copy-2-line" },
      { id: "tags", label: t("Теги"), icon: "ri-price-tag-3-line" },
      { id: "ai-assist", label: "AI Assist", icon: "ri-sparkling-line" },
      { id: "ai-prompts", label: "AI Prompts", icon: "ri-question-answer-line" },
      { id: "calls", label: t("Звонки"), icon: "ri-phone-line" },
    ],
  },
  {
    group: t("Данные"),
    items: [
      { id: "files", label: t("Файлы"), icon: "ri-folder-line" },
      { id: "import", label: t("Импорт контактов"), icon: "ri-upload-cloud-2-line" },
      { id: "data-export", label: t("Экспорт данных"), icon: "ri-download-cloud-2-line" },
    ],
  },
];

// разделы, до которых в макете реально можно доскроллить
export const conversationsNavAnchors: Record<string, string> = {
  dashboard: "#dashboard",
  "contact-fields": "#fields",
  lifecycle: "#lifecycle",
  channels: "#channels",
  widgets: "#widgets",
  calls: "#catalog",
  import: "#contacts-import",
  "data-export": "#data-export",
  "user-settings": "#user-settings",
  "team-settings": "#team-settings",
  snippets: "#snippets",
  tags: "#tags",
  "ai-assist": "#ai-assist",
  "ai-prompts": "#ai-prompts",
  "ai-knowledge": "#ai-knowledge",
};

export const conversationUnits = [
  { id: "hours", label: t("часов"), one: t("час"), few: t("часа") },
  { id: "days", label: t("дней"), one: t("день"), few: t("дня") },
  { id: "weeks", label: t("недель"), one: t("неделю"), few: t("недели") },
];

export const conversationCategories = [
  {
    id: "c-general",
    name: t("Общие вопросы"),
    description: t("Всё, что не подошло к другим категориям: приветствие, уточнение цены, условия работы."),
    color: "primary",
  },
  {
    id: "c-other",
    name: t("Другое"),
    description: t("Редкие обращения, для которых пока нет своей категории."),
    color: "neutral",
  },
  {
    id: "c-payment",
    name: t("Оплата"),
    description: t("Счета, способы оплаты, возвраты и вопросы по закрывающим документам."),
    color: "accent",
  },
  {
    id: "c-sales",
    name: t("Продажи"),
    description: t("Запрос коммерческого предложения, демо, обсуждение объёма и сроков."),
    color: "primary",
  },
];

// подсказки справа, как в оригинальном окне настроек
export const conversationHints = [
  {
    icon: "ri-chat-3-line",
    title: t("Диалог — это переписка"),
    text: t("Диалог связывает клиента с командой в конкретном канале: WhatsApp, Telegram или почта."),
  },
  {
    icon: "ri-chat-new-line",
    title: t("Диалог открывается"),
    text: t("Когда клиент пишет первым или сотрудник начинает переписку с контактом."),
  },
  {
    icon: "ri-checkbox-circle-line",
    title: t("Диалог закрывается"),
    text: t("Когда вопрос решён или активности нет дольше заданного срока."),
  },
  {
    icon: "ri-history-line",
    title: t("Контекст сохраняется"),
    text: t("Закрытые диалоги остаются в карточке клиента: история, заметки и оценка тональности."),
  },
];
